import {ActionBarActionName} from './types';

export enum MessagePartType {
  Text = `text`,
  Link = `link`,
  ActionLink = `action-link`,
  ActionButton = `action-button`,
}

export type GlobalActionBarBetaBannerEvent = CustomEvent<{value: string}>;

export type MessagePart =
  | {
      type: MessagePartType.Text;
      text: string;
    }
  | {
      type: MessagePartType.Link;
      text: string;
      href: string;
      newTab?: boolean;
    }
  | {
      type: MessagePartType.ActionLink;
      text: string;
      actionName: string;
      /** value passed back as ev.detail.value when action event is fired */
      value?: any;
    }
  | {
      type: MessagePartType.ActionButton;
      text: string;
      actionName: ActionBarActionName;
      /** value passed back as ev.detail.value when action event is fired */
      value?: any;
      icon?: string;
    };

export const MessagePartSpaceNode: MessagePart = {
  type: MessagePartType.Text,
  text: ` `,
};
